import style from "./style.scss";

const Center = ({ children }) => (
  <div class={style.center}>
    <div class={style.wrapper}>{children}</div>
  </div>
);

export default Center;
